import * as React from 'react'
const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={28} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m18.326 3.828 1.769 1.815 1.769-1.815M2.904 26.071h36.19M5.62 14v12.071M20.095 14v12.071m-4.524 0v-6.5a.917.917 0 0 0-.905-.928h-3.619c-.5 0-.904.416-.904.928v6.5M2.904 15.857 12.857 7.5l9.952 8.357m11.763-1.393 2.714 5.107H26.429l2.714-5.107h-2.714l3.347-5.571h-2.714l4.795-6.965 4.977 6.965h-2.715l3.167 5.571H34.57Zm-2.715 5.107v6.5"
    />
  </svg>
)
export default SvgComponent
